/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ baseName: NonNullable<unknown> }} Empty_Void_Space_NoneInputs */

const en_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.baseName}`)
};

const id_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tidak ada ${i?.baseName}`)
};

const ms_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiada ${i?.baseName}`)
};

const ca_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sense ${i?.baseName}`)
};

const cs_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Žádný ${i?.baseName}`)
};

const da_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingen ${i?.baseName}`)
};

const de_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kein ${i?.baseName}`)
};

const et_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} puudub`)
};

const es_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sin ${i?.baseName}`)
};

const fr_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucun ${i?.baseName}`)
};

const hr_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nema: ${i?.baseName}`)
};

const it_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun ${i?.baseName}`)
};

const lv_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nav ${i?.baseName}`)
};

const lt_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nėra ${i?.baseName}`)
};

const hu_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nem ${i?.baseName}`)
};

const nl_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geen ${i?.baseName}`)
};

const nb_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingen ${i?.baseName}`)
};

const pl_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brak ${i?.baseName}`)
};

const pt_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem ${i?.baseName}`)
};

const ro_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fără ${i?.baseName}`)
};

const sk_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nie ${i?.baseName}`)
};

const sl_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brez »${i?.baseName}«`)
};

const fi_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ei ${i?.baseName}`)
};

const sv_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingen ${i?.baseName}`)
};

const vi_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Không có ${i?.baseName}`)
};

const tr_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Yok`)
};

const el_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Όχι ${i?.baseName}`)
};

const bg_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Без ${i?.baseName}`)
};

const ru_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Нет ${i?.baseName}`)
};

const sr_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Без ${i?.baseName}`)
};

const uk_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Немає ${i?.baseName}`)
};

const ka_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName}-ის გარეშე`)
};

const hi_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`नो ${i?.baseName}`)
};

const th_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ไม่มี ${i?.baseName}`)
};

const ko_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} 없음`)
};

const zh_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无 ${i?.baseName}`)
};

const zh_tw_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無 ${i?.baseName}`)
};

const ja_empty_void_space_none = /** @type {(inputs: Empty_Void_Space_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} がありません`)
};

/**
* | output |
* | --- |
* | "No {baseName}" |
*
* @param {Empty_Void_Space_NoneInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const empty_void_space_none = /** @type {((inputs: Empty_Void_Space_NoneInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_Void_Space_NoneInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_empty_void_space_none(inputs)
	if (locale === "ms") return ms_empty_void_space_none(inputs)
	if (locale === "ca") return ca_empty_void_space_none(inputs)
	if (locale === "cs") return cs_empty_void_space_none(inputs)
	if (locale === "da") return da_empty_void_space_none(inputs)
	if (locale === "de") return de_empty_void_space_none(inputs)
	if (locale === "et") return et_empty_void_space_none(inputs)
	if (locale === "es") return es_empty_void_space_none(inputs)
	if (locale === "fr") return fr_empty_void_space_none(inputs)
	if (locale === "hr") return hr_empty_void_space_none(inputs)
	if (locale === "it") return it_empty_void_space_none(inputs)
	if (locale === "lv") return lv_empty_void_space_none(inputs)
	if (locale === "lt") return lt_empty_void_space_none(inputs)
	if (locale === "hu") return hu_empty_void_space_none(inputs)
	if (locale === "nl") return nl_empty_void_space_none(inputs)
	if (locale === "nb") return nb_empty_void_space_none(inputs)
	if (locale === "pl") return pl_empty_void_space_none(inputs)
	if (locale === "pt") return pt_empty_void_space_none(inputs)
	if (locale === "ro") return ro_empty_void_space_none(inputs)
	if (locale === "sk") return sk_empty_void_space_none(inputs)
	if (locale === "sl") return sl_empty_void_space_none(inputs)
	if (locale === "fi") return fi_empty_void_space_none(inputs)
	if (locale === "sv") return sv_empty_void_space_none(inputs)
	if (locale === "vi") return vi_empty_void_space_none(inputs)
	if (locale === "tr") return tr_empty_void_space_none(inputs)
	if (locale === "el") return el_empty_void_space_none(inputs)
	if (locale === "bg") return bg_empty_void_space_none(inputs)
	if (locale === "ru") return ru_empty_void_space_none(inputs)
	if (locale === "sr") return sr_empty_void_space_none(inputs)
	if (locale === "uk") return uk_empty_void_space_none(inputs)
	if (locale === "ka") return ka_empty_void_space_none(inputs)
	if (locale === "hi") return hi_empty_void_space_none(inputs)
	if (locale === "th") return th_empty_void_space_none(inputs)
	if (locale === "ko") return ko_empty_void_space_none(inputs)
	if (locale === "zh") return zh_empty_void_space_none(inputs)
	if (locale === "zh-tw") return zh_tw_empty_void_space_none(inputs)
	if (locale === "ja") return ja_empty_void_space_none(inputs)
	return en_empty_void_space_none(inputs)
});